module.exports = __webpack_public_path__ + "img/google-play.6d76baa0.png";